enum MenuType {
  BACK = 'back',
  BURGER = 'burger',
  CLOSE = 'close',
}

export default MenuType;
